import styled from '@emotion/styled'
import { colors } from '../colors'

export const IconContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  
  svg {
    display: block;
  }

  &.bg-gray
  {
    background-color: ${colors.gray300};
    padding:7px;
    border-radius: 8.75px;
  }
`